import React from 'react';
import { Section, SectionHeading } from '../ui/Section';
import { Reveal } from '../ui/Reveal';
import { ContentIcon } from '../ui/ContentIcon';
import { GlucoseCurve } from '../ui/GlucoseCurve';
import { mechanismSteps } from '../../data/content';
export function MechanismReveal() {
  return <Section className="bg-cream" aria-labelledby="mecanismo-titulo" data-id="element-128" data-mp="z65q1zy0xmpy">
      <div className="grid gap-12 lg:grid-cols-[1fr_1fr] lg:items-center lg:gap-20" data-id="element-129" data-mp="z8ihr4tl3bg7">
        <div data-id="element-130" data-mp="1mycttk62wvze">
          <Reveal data-id="element-131" data-mp="1mymb8jd25uth">
            <SectionHeading id="mecanismo-titulo" data-id="element-132" data-mp="1rv38c328jjip">La verdad que nadie te dice</SectionHeading>
          </Reveal>

          <ol className="mt-9 space-y-0 border-l-[3px] border-gold" data-id="element-133" data-mp="1d78eukgelb4k">
            {mechanismSteps.map((step, index) => <Reveal as="li" key={step.text} delay={index * 0.06} className="list-none" data-id="element-134" data-mp="1i4rvts4hk207" data-mpi={index}>
                <div className="flex items-start gap-4 py-4 pl-6" data-id="element-135" data-mp="25uuh9pdwa9pu">
                  <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-forest shadow-card" data-id="element-136" data-mp="2aludstj3qprt">
                    <ContentIcon name={step.icon} className="h-[18px] w-[18px]" data-id="element-137" data-mp="1fvocpyedoolp" />
                  </span>
                  <p className="text-base leading-relaxed text-ink sm:text-lg" data-id="element-138" data-mp="1awl8uha4wofb">{step.text}</p>
                </div>
              </Reveal>)}
          </ol>

          <Reveal delay={0.28} data-id="element-139" data-mp="1jw87ivbhbg4o">
            <p className="mt-9 text-xl font-bold text-forest sm:text-2xl" data-id="element-140" data-mp="1jvyeeyv50sur">
              Es biología. No es culpa tuya.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1} data-id="element-141" data-mp="1tm04fw71wlcb">
          <div className="rounded-2xl bg-white p-6 shadow-card sm:p-8" data-id="element-142" data-mp="1tmt309vuw4jd">
            <h3 className="text-sm font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-143" data-mp="27lj0vrqi288s">
              La misma comida, dos respuestas
            </h3>
            <GlucoseCurve className="mt-6" data-id="element-144" data-mp="23kpbetxeslds" />
          </div>
        </Reveal>
      </div>
    </Section>;
}